export default __webpack_public_path__ + "static/media/ceramx-indirect-restoration-after-cementation-and-polishing.225fb4a1.png";